import React, { useEffect, useRef, useState } from "react";
import JsBarcode from "jsbarcode";
import QRCode from "qrcode.react";

/**
 * Order numbers are long; WeChat 扫一扫 reliably reads QR, not dense Code128.
 * Use format "qr" for sales order nos; "code128" for shorter 1D barcodes.
 */
export default function BarcodeDisplay({
  value,
  height = 40,
  size = 120,
  align = "center",
  format = "code128",
}) {
  const svgRef = useRef(null);
  const [code128Ok, setCode128Ok] = useState(false);
  const text = String(value ?? "").trim();

  useEffect(() => {
    if (format === "qr") return;
    const node = svgRef.current;
    if (!node || !text) {
      setCode128Ok(false);
      return;
    }
    try {
      // Thick modules + large quiet zone so phone cameras / print stay scannable
      const moduleWidth = text.length > 20 ? 2 : text.length > 14 ? 2.2 : 2.5;
      JsBarcode(node, text, {
        format: "CODE128",
        displayValue: false,
        height: Math.max(48, Number(height) || 48),
        margin: 16,
        width: moduleWidth,
        background: "#ffffff",
        lineColor: "#000000",
      });
      setCode128Ok(true);
    } catch {
      setCode128Ok(false);
      if (node) node.innerHTML = "";
    }
  }, [text, height, format]);

  if (!text) {
    return (
      <div className="tpl-comp__barcode-fallback" style={{ textAlign: align }}>
        —
      </div>
    );
  }

  if (format === "qr") {
    const qrSize = Math.max(96, Number(size) || Number(height) || 120);
    return (
      <div className="tpl-comp__barcode-qr" style={{ textAlign: align }}>
        <QRCode
          value={text}
          size={qrSize}
          level="M"
          includeMargin
          renderAs="svg"
          bgColor="#ffffff"
          fgColor="#000000"
        />
      </div>
    );
  }

  return (
    <div className="tpl-comp__barcode-code128" style={{ textAlign: align }}>
      <svg
        ref={svgRef}
        className="tpl-comp__barcode-svg"
        style={{
          display: code128Ok ? "block" : "none",
          maxWidth: "100%",
          height: "auto",
          marginLeft: align === "right" ? "auto" : align === "center" ? "auto" : 0,
          marginRight: align === "left" ? 0 : "auto",
        }}
      />
      {!code128Ok ? (
        <div className="tpl-comp__barcode-fallback">{text}</div>
      ) : null}
    </div>
  );
}
